module.exports = __webpack_public_path__ + "img/fau.328c24d6.png";